import { Transition } from 'react-transition-group';
import React, { useContext } from 'react';
import {
  MenuLink,
  OverflowMenuLink,
  POPPER_TRANSITION_DURATION,
  SubMenuItemBase,
  SubMenuItemBaseItem,
  SubMenuItemToolTip,
} from './styles';
import { SidebarContext } from 'components/Sidebar/Sidebar';
import PopoverBase from 'components/PopoverBase';
import { black } from 'utils/style/colors';
import LocalIcon, { LocalIconTypes } from 'ui/LocalIcon';
import Marquee from '../Marquee/Marquee';

const popperModifier = {
  computeStyle: {
    gpuAcceleration: false,
  },
  hide: { enabled: false },
  inner: { enabled: true },
  preventOverflow: {
    enabled: false,
    padding: 0,
  },
};

type OwnProps = {
  exact?: boolean;
  label: string;
  path: string;
  iconType?: LocalIconTypes;
};

type ComponentProps = OwnProps & React.HTMLAttributes<HTMLElement>;

const SubMenuItem: React.FC<ComponentProps> = ({
  exact,
  label,
  path,
  iconType,
  ...restProps
}) => {
  const sideBarCollapsed = useContext(SidebarContext);
  if (!sideBarCollapsed) {
    return (
      <PopoverBase
        modifier={popperModifier}
        placement="right"
        trigger="hover"
        usePortal={true}
        target={
          <MenuLink path={path} exact={exact}>
            <SubMenuItemBase {...restProps}>
              <div
                style={{
                  background: 'var(--exact-white)',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {iconType && (
                  <LocalIcon iconName={iconType} color={`${black}`} type="sm" />
                )}
              </div>
              <SubMenuItemBaseItem>
                <Marquee text={label} />
              </SubMenuItemBaseItem>
            </SubMenuItemBase>
          </MenuLink>
        }
        childrenRenderFunc={({ placement, style, ref }) => (
          <Transition in={true} timeout={POPPER_TRANSITION_DURATION} appear>
            {(state) => (
              <OverflowMenuLink path={path} exact={exact}>
                <SubMenuItemToolTip
                  ref={ref}
                  style={style}
                  transitionState={state}
                  data-placement={placement}
                  {...restProps}
                >
                  <span>{label}</span>
                </SubMenuItemToolTip>
              </OverflowMenuLink>
            )}
          </Transition>
        )}
      />
    );
  }
  return (
    <MenuLink path={path} exact={exact}>
      <SubMenuItemBase {...restProps}>
        {iconType && (
          <LocalIcon iconName={`${iconType}`} color={`${black}`} type="sm" />
        )}
        <span>{label}</span>
      </SubMenuItemBase>
    </MenuLink>
  );
};

export default SubMenuItem;
